import React, { useCallback, useContext, useEffect, useState } from 'react';
import { Button, Modal } from 'antd';

import TicketContext from '@totem/components/ticketing/details/ticketContext';
import ProjectTicketCreate from '@totem/components/ticketing/ticket/specialCases/projectTicketCreate';
import { Project } from '@totem/components/ticketing/ticketing';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import IBDIcon from '@totem/styles/Icon';
import { isNotNull } from '@totem/utilities/common';
import { TICKET_ENDPOINT } from '@totem/utilities/endpoints';
import { CheckResponseShowError } from '@totem/utilities/responseUtilities';
const ButtonEditProject = () => {
  const { getApiToken } = useContext(UserProfileContext);
  const { onAction, ticket } = useContext(TicketContext);
  const [isSending, setIsSending] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [projectData, setProjectData] = useState<Project>(
    isNotNull(ticket)
      ? ticket.ticket.project
      : {
          startDate: '',
          endDate: '',
          status: 'PENDING',
          fee: 0.0,
          billedAmount: 0.0,
          budgetedHours: 0.0,
          actualHours: 0.0,
          billingType: '',
          expensesType: '',
        },
  );
  useEffect(() => {
    if (isNotNull(ticket) && isNotNull(ticket.ticket.project)) {
      setProjectData(ticket.ticket.project);
    }
  }, [ticket.ticket.project]);
  const sendProjectUpdate = useCallback(
    async (paramTicketId: string, payload: Project) => {
      if (!isSending) {
        fetch(`${TICKET_ENDPOINT}/${paramTicketId}/project`, {
          method: 'POST',
          headers: new Headers({
            Authorization: `Bearer ${getApiToken()}`,
          }),
          body: JSON.stringify(payload),
        }).then((res) => {
          setIsSending(false);
          const success = CheckResponseShowError(res);
          if (success) {
            setShowEdit(false);

            onAction('refresh', '');
          }
        });
      }
    }, // End async
    [],
  );

  const handleSubmit = () => {
    if (isNotNull(ticket) && isNotNull(ticket.ticket)) {
      sendProjectUpdate(ticket.ticket.id, projectData);
    }
  };
  return (
    <>
      <Button
        icon={<IBDIcon name={'Edit'} />}
        type="primary"
        onClick={() => setShowEdit(true)}
      >
        Edit Project
      </Button>
      {showEdit && isNotNull(ticket) && (
        <Modal
          open={showEdit}
          title="Update Project Details"
          onCancel={() => {
            setShowEdit(false);
          }}
          onOk={handleSubmit}
          footer={[
            <Button
              key="cancel"
              onClick={() => {
                setShowEdit(false);
              }}
            >
              Cancel
            </Button>,
            <Button key="submit" type="primary" onClick={handleSubmit}>
              Submit
            </Button>,
          ]}
        >
          <ProjectTicketCreate
            isEdit
            project={projectData}
            onChange={(prjUpdate: Project) => {
              setProjectData(prjUpdate);
            }}
          />
        </Modal>
      )}
    </>
  );
};
export default ButtonEditProject;
